import { render, staticRenderFns } from "./sensitiveWord-item.vue?vue&type=template&id=3a6fdf6e&scoped=true"
import script from "./sensitiveWord-item.vue?vue&type=script&lang=js"
export * from "./sensitiveWord-item.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWord-item.vue?vue&type=style&index=0&id=3a6fdf6e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6fdf6e",
  null
  
)

export default component.exports